module.exports = __webpack_public_path__ + "static/img/92052A_1_R_20220712_fit.d2fa526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92052A_1_R_20220712_fit.png
// module id = LdDe
// module chunks = 0